<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: 'マスターユーザー',
        items: [
          {
            text: '一覧',
            router: { name: 'masterAdminUserAuths' }
          },
          {
            text: '監査ログ',
            router: { name: 'masterAdminAuditLogs' }
          }
        ]
      }
    ]
  })
}
</script>
